import React, {Fragment} from "react";
import {ModalError} from "views/components/modals/error/modal_error.component";
import {ConfirmModal} from "views/components/modals/confirm_modal/confirm_modal.component";
import {TeamSavedModal} from "./team_saved_modal/team_saved_modal.component";
import {InfoTradeModal} from "views/components/modals/info_trade_modal/info_trade_modal.component";
import {ModalAccountUpdated} from "views/components/modals/account/account_updated.component";
import {LeagueJoinedModal} from "views/components/modals/league_joined/league_joined.component";
import {HowToScoreModal} from "views/components/modals/how_to_score/how_to_score.component";
import {InfoSessionModal} from "./info_session_modal/info_session_modal.component";

export const Modals: React.FC = () => {
	return (
		<Fragment>
			<ModalError />
			<ConfirmModal />
			<TeamSavedModal />
			<InfoTradeModal />
			<ModalAccountUpdated />
			<LeagueJoinedModal />
			<HowToScoreModal />
			<InfoSessionModal />
		</Fragment>
	);
};
